import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { productsJsmRovoAiAuditLogsRoute } from '@jira/router-routes__products-jsm-ai-governance-native-ai-capabilities-routes/src/productsJsmRovoAiAuditLogsRoute.tsx';
import { productJsmAiGovernanceAuditLogsEntryPoint } from '@jira/spa-apps__admin-pages-product-jsm-ai-governance/src/productJsmAiGovernanceAuditLogsEntryPoint.entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { productsJsmRovoAiAuditLogsLayout } from './productsJsmRovoAiAuditLogsLayout.tsx';

const entryPoint = createPageEntryPoint({ main: productJsmAiGovernanceAuditLogsEntryPoint });

export const productsJsmRovoAiAuditLogsRouteEntry: Route = createEntry(
	productsJsmRovoAiAuditLogsRoute,
	() => ({
		group: 'global-settings',
		entryPoint: () =>
			fg('enable-rovo-ai-audit-logs-for-jsm') ? entryPoint : notFoundPageEntrypoint,
		layout: productsJsmRovoAiAuditLogsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
			menuId: MenuIdSettings,
		},

		resources: fg('enable-rovo-ai-audit-logs-for-jsm')
			? [
					...getNavigationResources(),
					...getNavigationSidebarProductsSettingResource(),
					...jiraSpaResources(),
				]
			: getNavigationResources(),
		ufoName: 'admin.jsm-rovo-ai-audit-logs',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
